import PillTextBox, { PillColorTheme } from 'components/Common/PillTextBox'
import { FC } from 'react'
import Settings from 'components/Owner/Tools/Settings'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface IPillBoxAndSetting {
  isToolDisconnecting: boolean
  isConnected?: boolean
  handleDisconnect: () => void
  readonly?: boolean
}

const PillBoxAndSetting: FC<IPillBoxAndSetting> = ({
  isToolDisconnecting,
  isConnected,
  handleDisconnect,
  readonly,
}) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-row gap-4">
      {!isToolDisconnecting && (
        <PillTextBox
          colorTheme={isConnected ? PillColorTheme.SUCCESS : PillColorTheme.ERROR}
          size="small"
        >
          {isConnected ? t('tools.status.connected') : t('tools.status.notConnected')}
        </PillTextBox>
      )}
      {isConnected && (
        <div>
          <Settings handleDisconnect={handleDisconnect} disabled={!isConnected || readonly} />
        </div>
      )}
    </div>
  )
}

export default PillBoxAndSetting
